/* Shanti Enterprise AG – «mit Artikelnummer bestellen» V2 (07.10.2026)
   Vorschläge aus dem ERP (n8n), Shop-Abgleich über Shopify Predictive Search,
   Sammel-Warenkorb über /cart/add.js, Drawer öffnet sich. */
(function () {
  'use strict';
  var root = document.getElementById('shanti-artikelnummer');
  if (!root) return;

  var ENDPOINT = root.dataset.endpoint;
  var TOKEN = root.dataset.token;
  var PLACEHOLDER = root.dataset.placeholderVariant;
  var CART_ADD = root.dataset.cartAdd || '/cart/add.js';
  var rowsEl = root.querySelector('.sa__rows');
  var tpl = root.querySelector('.sa__row-tpl');
  var msgEl = root.querySelector('.sa__msg');
  var countEl = root.querySelector('.sa__count');
  var submitBtn = root.querySelector('.sa__submit') || document.createElement('button');
  /* Hinweis: die Singleton-App entfernt für Gäste alle Buttons im Produktformular – deshalb überall null-sicher */
  function on(sel, ev, fn) { var el = root.querySelector(sel); if (el) el.addEventListener(ev, fn); return el; }

  var shopCache = {};   // nr -> {variantId, title, image} | null

  function norm(s) { return String(s || '').trim().toUpperCase(); }

  /* ---------- Shop-Abgleich (Predictive Search) ---------- */
  function lookupShop(nr) {
    var key = norm(nr);
    if (key in shopCache) return Promise.resolve(shopCache[key]);
    var url = '/search/suggest.json?q=' + encodeURIComponent(key) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=show&resources[options][fields]=variants.sku';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) return null;
        // Predictive Search liefert keine SKU je Variante -> Produkt-JSON nachladen (enthält variants[].sku)
        return Promise.all(products.slice(0, 4).map(function (p) {
          return fetch('/products/' + p.handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (full) {
          var found = null;
          full.forEach(function (pj) {
            if (found || !pj) return;
            (pj.variants || []).forEach(function (v) {
              if (!found && norm(v.sku) === key) {
                var img = (v.featured_image && v.featured_image.src) || (pj.images && pj.images[0]) || pj.featured_image || '';
                found = { variantId: v.id, title: pj.title, image: img, url: '/products/' + pj.handle, available: v.available };
              }
            });
          });
          return found;
        });
      })
      .then(function (found) { shopCache[key] = found || null; return found || null; })
      .catch(function () { shopCache[key] = null; return null; });
  }

  /* ---------- ERP-Vorschläge ---------- */
  var controllers = {};
  function suggest(q, rowId) {
    if (controllers[rowId]) controllers[rowId].abort();
    var ctrl = new AbortController();
    controllers[rowId] = ctrl;
    var url = ENDPOINT + '?token=' + encodeURIComponent(TOKEN) + '&q=' + encodeURIComponent(q) + '&limit=10';
    return fetch(url, { signal: ctrl.signal })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  /* ---------- Zeilen ---------- */
  var rowSeq = 0;
  function addRow(nr, qty) {
    var frag = tpl.content.cloneNode(true);
    var row = frag.querySelector('.sa__row');
    row.dataset.id = String(++rowSeq);
    row.dataset.status = 'empty';
    rowsEl.appendChild(frag);
    var el = rowsEl.lastElementChild;
    bindRow(el);
    if (nr) { el.querySelector('.sa__nr').value = nr; resolveRow(el, nr); }
    if (qty) el.querySelector('.sa__q').value = qty;
    updateCount();
    return el;
  }

  function setState(row, status, text) {
    row.dataset.status = status;           // empty | searching | shop | erp | unknown | error
    row.querySelector('.sa__state').textContent = status === 'shop' ? '✓' : status === 'erp' ? '◐' : status === 'unknown' ? '?' : status === 'searching' ? '…' : '';
    row.querySelector('.sa__bez').textContent = text || '';
  }

  function showImg(row, src, href) {
    var box = row.querySelector('.sa__img');
    if (!box) return;
    if (!src) { box.hidden = true; box.innerHTML = ''; return; }
    var s = String(src).replace(/(\.[a-z]{3,4})(\?|$)/i, '_200x200$1$2');
    box.innerHTML = '<a href="' + esc(href || '#') + '" target="_blank" rel="noopener"><img src="' + esc(s) + '" alt="" loading="lazy"></a>';
    box.hidden = false;
  }
  function hideList(row) { var l = row.querySelector('.sa__list'); l.hidden = true; l.innerHTML = ''; row._active = -1; }

  function renderList(row, data) {
    var list = row.querySelector('.sa__list');
    list.innerHTML = '';
    row._active = -1;
    if (!data || !data.ok) { list.hidden = true; return; }
    var items = data.items || [];
    var sugg = data.suggestions || [];
    if (!items.length && !sugg.length) {
      list.innerHTML = '<li class="sa__li sa__li--none">Keine passende Nummer gefunden</li>';
      list.hidden = false;
      return;
    }
    function li(it, cls) {
      var l = document.createElement('li');
      l.className = 'sa__li' + (cls ? ' ' + cls : '');
      l.setAttribute('role', 'option');
      l.dataset.nr = it.nr;
      l.dataset.bez = it.bez || '';
      l.innerHTML = '<span class="sa__li-nr">' + esc(it.nr) + '</span><span class="sa__li-bez">' + esc(it.bez || '') + '</span>';
      list.appendChild(l);
    }
    items.forEach(function (it) { li(it, ''); });
    if (sugg.length) {
      var h = document.createElement('li');
      h.className = 'sa__li sa__li--head';
      h.textContent = 'Meinten Sie …';
      list.appendChild(h);
      sugg.forEach(function (it) { li(it, 'sa__li--fuzzy'); });
    }
    list.hidden = false;
  }

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function choose(row, nr, bez) {
    var input = row.querySelector('.sa__nr');
    input.value = nr;
    row.dataset.nr = nr;
    row.dataset.bez = bez || '';
    hideList(row);
    resolveRow(row, nr, bez);
    var q = row.querySelector('.sa__q');
    q.focus(); q.select();
  }

  function resolveRow(row, nr, bezHint) {
    setState(row, 'searching', bezHint || 'Prüfe …');
    row.dataset.nr = nr;
    lookupShop(nr).then(function (shop) {
      if (row.dataset.nr !== nr) return;
      if (shop) {
        row.dataset.variantId = String(shop.variantId);
        row.dataset.bez = shop.title || bezHint || '';
        setState(row, 'shop', (shop.title || bezHint || '') + ', im Shop');
        showImg(row, shop.image, shop.url);
      } else {
        row.dataset.variantId = '';
        if (bezHint) {
          row.dataset.bez = bezHint;
          setState(row, 'erp', bezHint + ', nicht im Online-Shop, wird mit Nummer bestellt');
        } else {
          // Nummer direkt getippt: im ERP nachsehen, ob sie existiert
          suggest(nr, 'r' + row.dataset.id).then(function (data) {
            if (row.dataset.nr !== nr) return;
            var exact = data && data.ok && (data.items || []).filter(function (it) { return norm(it.nr) === norm(nr); })[0];
            if (exact) { row.dataset.bez = exact.bez || ''; setState(row, 'erp', (exact.bez || '') + ', nicht im Online-Shop, wird mit Nummer bestellt'); }
            else { row.dataset.bez = ''; setState(row, 'unknown', 'Nummer unbekannt, wird trotzdem als Anfrage mit dieser Nummer übermittelt'); }
          });
        }
      }
      updateCount();
    });
  }

  function bindRow(row) {
    var input = row.querySelector('.sa__nr');
    var list = row.querySelector('.sa__list');
    var q = row.querySelector('.sa__q');
    var timer;

    input.addEventListener('input', function () {
      row.dataset.nr = ''; row.dataset.variantId = ''; row.dataset.bez = '';
      setState(row, 'empty', ''); showImg(row, '');
      clearTimeout(timer);
      var v = input.value.trim();
      if (v.replace(/[^0-9A-Za-z]/g, '').length < 2) { hideList(row); return; }
      timer = setTimeout(function () {
        suggest(v, 'r' + row.dataset.id).then(function (data) { if (data) renderList(row, data); });
      }, 250);
    });

    input.addEventListener('keydown', function (e) {
      var opts = list.hidden ? [] : Array.prototype.slice.call(list.querySelectorAll('.sa__li[data-nr]'));
      if (e.key === 'ArrowDown' && opts.length) { e.preventDefault(); row._active = Math.min((row._active || -1) + 1, opts.length - 1); mark(opts, row._active); }
      else if (e.key === 'ArrowUp' && opts.length) { e.preventDefault(); row._active = Math.max((row._active || 0) - 1, 0); mark(opts, row._active); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        if (opts.length && row._active >= 0) { var o = opts[row._active]; choose(row, o.dataset.nr, o.dataset.bez); }
        else if (opts.length === 1) { choose(row, opts[0].dataset.nr, opts[0].dataset.bez); }
        else if (input.value.trim()) { hideList(row); clearTimeout(timer); resolveRow(row, input.value.trim()); q.focus(); q.select(); }
      }
      else if (e.key === 'Escape') { hideList(row); }
      else if (e.key === 'Tab' && input.value.trim() && row.dataset.status === 'empty') { clearTimeout(timer); hideList(row); resolveRow(row, input.value.trim()); }
    });

    input.addEventListener('blur', function () {
      setTimeout(function () {
        hideList(row);
        var v = input.value.trim();
        if (v && row.dataset.status === 'empty') { clearTimeout(timer); resolveRow(row, v); }
      }, 180);
    });

    list.addEventListener('mousedown', function (e) {
      var li = e.target.closest('.sa__li[data-nr]');
      if (!li) return;
      e.preventDefault();
      choose(row, li.dataset.nr, li.dataset.bez);
    });

    var minus = row.querySelector('.sa__minus'), plus = row.querySelector('.sa__plus'), rem = row.querySelector('.sa__remove');
    if (minus) minus.addEventListener('click', function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { q.value = Math.min(999, (parseInt(q.value, 10) || 1) + 1); });
    q.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); var next = row.nextElementSibling; if (!next) next = addRow(); next.querySelector('.sa__nr').focus(); }
    });
    if (rem) rem.addEventListener('click', function () {
      if (rowsEl.children.length === 1) { input.value = ''; row.dataset.nr = ''; row.dataset.variantId = ''; setState(row, 'empty', ''); showImg(row, ''); q.value = 1; }
      else row.remove();
      updateCount();
    });
  }

  function mark(opts, idx) { opts.forEach(function (o, i) { o.classList.toggle('is-active', i === idx); }); if (opts[idx]) opts[idx].scrollIntoView({ block: 'nearest' }); }

  function updateCount() {
    var rows = Array.prototype.slice.call(rowsEl.querySelectorAll('.sa__row'));
    var filled = rows.filter(function (r) { return (r.querySelector('.sa__nr').value || '').trim(); });
    var pieces = filled.reduce(function (s, r) { return s + (parseInt(r.querySelector('.sa__q').value, 10) || 1); }, 0);
    countEl.textContent = filled.length ? filled.length + ' Position' + (filled.length > 1 ? 'en' : '') + ', ' + pieces + ' Stück' : '';
    submitBtn.disabled = filled.length === 0;
  }

  /* ---------- Liste einfügen ---------- */
  var pasteBox = root.querySelector('.sa__paste');
  on('.sa__paste-open', 'click', function () { pasteBox.hidden = !pasteBox.hidden; if (!pasteBox.hidden) pasteBox.querySelector('textarea').focus(); });
  on('.sa__paste-cancel', 'click', function () { pasteBox.hidden = true; });
  function applyLines(lines) {
    lines = lines.map(function (l) { return String(l).trim(); }).filter(Boolean);
    if (!lines.length) return 0;
    var first = rowsEl.querySelector('.sa__row');
    if (first && !(first.querySelector('.sa__nr').value || '').trim() && rowsEl.children.length === 1) first.remove();
    // leere Zeilen am Ende entfernen
    Array.prototype.slice.call(rowsEl.querySelectorAll('.sa__row')).forEach(function (r) { if (!(r.querySelector('.sa__nr').value || '').trim()) r.remove(); });
    var n = 0;
    lines.forEach(function (l) {
      if (/^(artikel|art\.?nr|nummer|sku|menge)/i.test(l)) return;   // Kopfzeile überspringen
      var m = l.match(/^(.+?)[\s;,\t|]+(\d{1,3})\s*$/);
      var nr = m ? m[1].trim() : l.replace(/[;,\t|]+$/, '').trim();
      var qty = m ? parseInt(m[2], 10) : 1;
      if (!nr) return;
      addRow(nr, qty); n++;
    });
    updateCount();
    return n;
  }
  on('.sa__paste-apply', 'click', function () {
    var n = applyLines(pasteBox.querySelector('textarea').value.split(/\r?\n/));
    pasteBox.querySelector('textarea').value = '';
    pasteBox.hidden = true;
    if (n) setMsg(n + ' Zeile' + (n > 1 ? 'n' : '') + ' übernommen. Nummern werden geprüft.', 'ok');
  });

  /* ---------- Datei (CSV/TSV/Excel) ---------- */
  function readFile(file) {
    if (!file) return;
    var name = (file.name || '').toLowerCase();
    setMsg('Lese ' + file.name + ' …');
    if (/\.(xlsx|xls)$/.test(name)) {
      loadSheetJs().then(function () {
        var fr = new FileReader();
        fr.onload = function (e) {
          try {
            var wb = XLSX.read(new Uint8Array(e.target.result), { type: 'array' });
            var ws = wb.Sheets[wb.SheetNames[0]];
            var rows = XLSX.utils.sheet_to_json(ws, { header: 1, blankrows: false });
            var lines = rows.map(function (r) { return [r[0], r[1]].filter(function (x) { return x !== undefined && x !== null && x !== ''; }).join(';'); });
            var n = applyLines(lines);
            pasteBox.hidden = true;
            setMsg(n + ' Zeilen aus ' + file.name + ' übernommen. Nummern werden geprüft.', 'ok');
          } catch (err) { setMsg('Datei konnte nicht gelesen werden.', 'error'); }
        };
        fr.readAsArrayBuffer(file);
      }).catch(function () { setMsg('Excel-Modul konnte nicht geladen werden. Bitte als CSV speichern.', 'error'); });
    } else {
      var fr2 = new FileReader();
      fr2.onload = function (e) {
        var n = applyLines(String(e.target.result).split(/\r?\n/));
        pasteBox.hidden = true;
        setMsg(n + ' Zeilen aus ' + file.name + ' übernommen. Nummern werden geprüft.', 'ok');
      };
      fr2.readAsText(file);
    }
  }
  function loadSheetJs() {
    if (window.XLSX) return Promise.resolve();
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
      s.onload = res; s.onerror = rej; document.head.appendChild(s);
    });
  }
  var fileInput = root.querySelector('.sa__file');
  if (fileInput) fileInput.addEventListener('change', function () { readFile(fileInput.files[0]); fileInput.value = ''; });
  ['dragenter', 'dragover'].forEach(function (ev) { root.addEventListener(ev, function (e) { if (e.dataTransfer && Array.prototype.indexOf.call(e.dataTransfer.types, 'Files') >= 0) { e.preventDefault(); root.classList.add('is-dragover'); } }); });
  ['dragleave', 'drop'].forEach(function (ev) { root.addEventListener(ev, function () { root.classList.remove('is-dragover'); }); });
  root.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) { e.preventDefault(); readFile(e.dataTransfer.files[0]); } });

  /* ---------- Nachbestellen aus früherer Bestellung ---------- */
  Array.prototype.slice.call(root.querySelectorAll('.sa__order')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var raw = btn.dataset.items || '';
      var lines = raw.split(';').map(function (x) { return x.trim(); }).filter(Boolean).map(function (x) { var p = x.split('|'); return p[0] + ';' + (p[1] || '1'); });
      var n = applyLines(lines);
      setMsg(n + ' Positionen aus ' + btn.querySelector('.sa__order-name').textContent + ' übernommen. Mengen anpassen und in den Warenkorb.', 'ok');
      rowsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  on('.sa__addrow', 'click', function () { var first = addRow(); addRow(); addRow(); addRow(); addRow(); first.querySelector('.sa__nr').focus(); });

  /* ---------- Warenkorb ---------- */
  function setMsg(text, kind) { msgEl.textContent = text || ''; msgEl.className = 'sa__msg' + (kind ? ' sa__msg--' + kind : ''); }

  submitBtn.addEventListener('click', function () {
    var rows = Array.prototype.slice.call(rowsEl.querySelectorAll('.sa__row')).filter(function (r) { return (r.querySelector('.sa__nr').value || '').trim(); });
    if (!rows.length) return;
    var pending = rows.filter(function (r) { return r.dataset.status === 'searching' || r.dataset.status === 'empty'; });
    if (pending.length) {
      // noch nicht geprüfte Zeilen zuerst auflösen
      setMsg('Prüfe Artikelnummern …');
      Promise.all(pending.map(function (r) {
        var nr = r.querySelector('.sa__nr').value.trim();
        resolveRow(r, nr);
        return new Promise(function (res) { var t = setInterval(function () { if (r.dataset.status !== 'searching' && r.dataset.status !== 'empty') { clearInterval(t); res(); } }, 100); setTimeout(function () { clearInterval(t); res(); }, 6000); });
      })).then(function () { submitBtn.click(); });
      return;
    }
    var items = rows.map(function (r) {
      var nr = r.querySelector('.sa__nr').value.trim();
      var qty = Math.max(1, parseInt(r.querySelector('.sa__q').value, 10) || 1);
      var vid = r.dataset.variantId;
      if (vid) return { id: Number(vid), quantity: qty, properties: { 'Artikelnummer': nr } };
      return { id: Number(PLACEHOLDER), quantity: qty, properties: { 'Artikelnummer': nr, 'Custom SKU': nr, 'Bezeichnung': r.dataset.bez || '' } };
    });
    // gleiche Varianten zusammenfassen
    var merged = [];
    items.forEach(function (it) {
      var same = merged.find(function (m) { return m.id === it.id && JSON.stringify(m.properties) === JSON.stringify(it.properties); });
      if (same) same.quantity += it.quantity; else merged.push(it);
    });

    submitBtn.disabled = true; submitBtn.classList.add('is-loading');
    setMsg('Wird in den Warenkorb gelegt …');
    var cart = document.querySelector('cart-drawer');
    var body = { items: merged };
    if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(','); body.sections_url = window.location.pathname; }

    fetch(CART_ADD, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        submitBtn.classList.remove('is-loading');
        if (res.status || res.message === 'Cart Error' || res.description) {
          setMsg('Fehler: ' + (res.description || res.message || 'Artikel konnte nicht hinzugefügt werden'), 'error');
          submitBtn.disabled = false;
          return;
        }
        var n = merged.reduce(function (s, i) { return s + i.quantity; }, 0);
        setMsg(n + ' Stück in den Warenkorb gelegt.', 'ok');
        if (cart && res.sections) {
          try { cart.renderContents(res); if (cart.open) cart.open(); } catch (e) { /* ignore */ }
        } else {
          window.location.href = '/cart';
        }
        rowsEl.innerHTML = '';
        addRow();
        updateCount();
      })
      .catch(function () { submitBtn.classList.remove('is-loading'); submitBtn.disabled = false; setMsg('Verbindungsfehler. Bitte nochmals versuchen.', 'error'); });
  });

  /* ---------- Start ---------- */
  /* ?nr=12-001 (z. B. aus der Kopfzeilen-Suche): erste Zeile vorbelegen und sofort auflösen */
  var preNr = '';
  try { preNr = (new URLSearchParams(window.location.search).get('nr') || '').trim(); } catch (e) { /* ignore */ }
  if (preNr) {
    var preRow = addRow(preNr, 1);
    addRow(); addRow();
    setTimeout(function () { try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { /* ignore */ } }, 300);
  } else {
    addRow(); addRow(); addRow();
  }
  updateCount();
})();
